module.exports = __webpack_public_path__ + "img/forgot-password-dark.04ded96a.svg";